import { CUSTOMER_PROFILE, RESET_CUSTOMER } from '../actionTypes';
const initialState = {
  customerId: '',
  comtomerName: '',
  comtomerShortName: '',
  customerTypeId: '',
  businessTypeId: '',
  address: '',
  phone: '',
  lat: null,
  lng: null,
  profileImg: null,
  comCode: '',
  createdBy: '',
  createdAt: '',
  updatedBy: '',
  updatedAt: '',
  deleted: false,
  position: null,
  description: null,
  locationName: '',
  valuePrivacy: '',
  selectPrivacy: '',
  taxNo: null,
  type: '',
  orgId: '',
  mappingCode1: null,
  mappingCode2: null,
  mappingCode3: null,
  email: null,
  refId: '',
  refFromCode: '',
  username: '',
  kycStatus: '',
  referredPhone: null,
};

export const customerProfileReducer = (state = initialState, action) => {
  
  switch (action.type) {
    case CUSTOMER_PROFILE:
      // //console.log('customerProfileReducer action xxxxxxxxxxxx: ',action.type ,action.data );
      return {
        ...state,
        ...action.data,
      };
    default:
      return state;
  }
};
